import { render, staticRenderFns } from "./EditToolbar.vue?vue&type=template&id=3590535d"
import script from "./EditToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./EditToolbar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditToolbar.vue?vue&type=style&index=0&id=3590535d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports